import Swiper, { EffectFade, Navigation, Scrollbar, Controller, Pagination, Autoplay } from "swiper";

var debug = false;

const paginationConjunction = (document.documentElement.lang == 'es') ? 'de' : 'of';

const heroSwiper = () => {
  const swiper = new Swiper(".swiper", {
    modules: [EffectFade, Autoplay, Navigation, Pagination],
    autoplay: {
      delay: 8000,
    },
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      centeredSlides: true,
      renderFraction: function (currentClass, totalClass) {
        return (
          '<span class="' +
          currentClass +
          '"></span>' +
          " <span class='pagi-br'> " + paginationConjunction + " </span> " +
          '<span class="' +
          totalClass +
          '"></span>'
        );
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1,
  });
  const upNext = document.querySelector(".js-swiper-next");

  const nextSlidePreview = () => {
    if(!upNext){
      return;
    }
    //preview_text_for_next_slide
    let thisSlide = swiper.activeIndex;
    let _thisSlide = swiper.slides[thisSlide];
    let previewTextField = document.querySelector('[data-upnext]');
    if(!previewTextField){
      return;
    }
    let previewText = _thisSlide.getAttribute('data-upnext');
    upNext.innerHTML = "";
    upNext.insertAdjacentHTML("afterbegin", previewText);
  };

  nextSlidePreview();

  swiper.on("transitionStart", function () {
    nextSlidePreview();
  });

  swiper.on("reachEnd", function () {
    const nextSlide = document.querySelector(".swiper-next");
    if(nextSlide) {
      nextSlide.classList.add("-hide");
    }
  });
};
heroSwiper();

const sliderPanels = () => {
  const heroBlocks = Array.from(document.querySelectorAll(".swiper-panel"));
  // Possibly multiple sliders on the page, so each needs a unique class to bind each slider to
  const heroBlocksInner = Array.from(
    document.querySelectorAll(".swiper-panel .swiper-inner")
  );
  for (let i = 0; i < heroBlocksInner.length; i++) {
    const slider = heroBlocksInner[i];
    slider.classList.add("swiper-inner--" + i);
  }
  heroBlocks.forEach((elem, i) => {
    //console.log("Swiper panel Swiper-inner init", i);
    const heroSwiper = new Swiper(".swiper-inner--" + i, {
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      breakpoints: {
        480: {
          slidesPerView: 2.2,
          spaceBetween: 30,
          centeredSlides: false,
        },
        860: {
          slidesPerView: 2.4,
          spaceBetween: 30,
          centeredSlides: false,
        },
      },
      /*pagination: {
        el: ".swiper-pagination",
      },*/
      pagination: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    });
  });
};
sliderPanels();

const peopleCardPanels = () => {
  const peopleBlocks = Array.from(
    document.querySelectorAll(".swiper-panel__people")
  );
  // Possibly multiple sliders on the page, so each needs a unique class to bind each slider to
  const peopleInner = Array.from(
    document.querySelectorAll(".swiper-panel__people .swiper-inner")
  );
  //TODO: Buttons for pagination need to be unique
  for (let i = 0; i < peopleInner.length; i++) {
    const slider = peopleInner[i];
    slider.classList.add("swiper-inner--" + i);
  }
  peopleBlocks.forEach((elem, i) => {
    //console.log("Swiper panel Swiper-inner init", i);
    const heroSwiper = new Swiper(".swiper-inner--" + i, {
      modules: [EffectFade, Autoplay, Navigation, Pagination],
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      breakpoints: {
        480: {
          slidesPerView: 2.2,
          spaceBetween: 30,
          centeredSlides: false,
        },
        860: {
          slidesPerView: 3,
          spaceBetween: 30,
          centeredSlides: false,
        },
      },
      /*pagination: {
        el: ".swiper-pagination",
      },*/
      pagination: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    });
  });
};
peopleCardPanels();

const testimonialPanels = () => {
  const testimonialBlocks = Array.from(
    document.querySelectorAll(".swiper-panel__testimonials")
  );

  testimonialBlocks.forEach((elem, i) => {
    if (debug) {
      console.log("Testimonials Swiper-inner init", i);
    }
    const heroSwiper = new Swiper(".swiper-inner", {
      modules: [EffectFade, Autoplay, Navigation, Pagination],
      watchOverflow: true,
      slidesPerView: 1,
      //loop: true,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
        centeredSlides: true,
        renderFraction: function (currentClass, totalClass) {
          return (
            '<span class="' +
            currentClass +
            '"></span>' +
            " <span class='pagi-br'> " + paginationConjunction + " </span> " +
            '<span class="' +
            totalClass +
            '"></span>'
          );
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      },

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
};
testimonialPanels();

// const testSwiper = () => {
//   const newTestSwiper = new Swiper('.test-swiper', {
//     slidesPerView: 2,
//     pagination: false,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//   });
// };
// testSwiper();

const cardPanels = () => {
  const cardBlocks = Array.from(
    document.querySelectorAll(".swiper-panel__cards")
  );

  //console.log("cardPanels", cardBlocks);

  const cardBlocksInner = Array.from(
    document.querySelectorAll(
      ".swiper-panel__cards .swiper-panel__cards--inner"
    )
  );

  const addUniqueClassesToPanels = () => {
    for (let i = 0; i < cardBlocksInner.length; i++) {
      console.log("swiper for loop index? ", i);
      const slider = cardBlocksInner[i];
      slider.classList.add("swiper-panel__cards--inner--" + i);
    }
  };

  const initSwiperPanels = () => {
    cardBlocks.forEach((elem, i) => {
      let elemDataAtt = elem.getAttribute("data-tab");
      let swiperTarget;
      if ((elemDataAtt = "slider-panel-1")) {
        swiperTarget = ".swiper-panel__cards--inner";
      } else {
        swiperTarget = ".swiper-panel__cards--inner--" + i++;
      }
      const cardSwiper = new Swiper(swiperTarget, {
        modules: [EffectFade, Autoplay, Navigation, Pagination],
        //watchOverflow: true,
        slidesPerView: 1,
        //loop: true,
        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          860: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
        //pagination: {
        //el: ".swiper-pagination",
        //},
        pagination: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      });
    }); // end card blocks
  }; // end initSwiperPanels

  const initPanels = new Promise(addUniqueClassesToPanels);
  initPanels.then(initSwiperPanels());

};
cardPanels();


const iconSliders = () => {
  const iconSliderBlocks = Array.from(
    document.querySelectorAll(".icon-slider-block")
  );

  iconSliderBlocks.forEach((elem, i) => {
    if (debug) {
      console.log("icon-slider-block init", i);
    }
    let slides = elem.querySelectorAll(".swiper-slide");

    if (slides.length < 5) {
      //console.log('less than 5 icon slides');
      let iconSliderInner = elem.querySelector('.icon-slider-inner');
      iconSliderInner.classList.add('disabled');
    }

    const iconsSwiper = new Swiper(".icon-slider-inner", {
      modules: [EffectFade, Autoplay, Navigation, Pagination],
      watchOverflow: true,
      slidesPerView: 1.5,
      spaceBetween: 30,
      //loop: true,
      breakpoints: {
        600: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
        860: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        1300: {
          slidesPerView: 5,
          spaceBetween: 30,
        },
      },

      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
        centeredSlides: true,
        renderFraction: function (currentClass, totalClass) {
          return (
            '<span class="' +
            currentClass +
            '"></span>' +
            " <span class='pagi-br'> " + paginationConjunction + " </span> " +
            '<span class="' +
            totalClass +
            '"></span>'
          );
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      },

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
};
iconSliders();




/**
 * Modal slider
 * @param {int} - activeIndex of slider (ie. id of slide clicked)
 */
const modalSwiper = (activeIndex) => {
  //console.log("modalSwiper");
  const swiper = new Swiper(".swiper-modal", {
    modules: [EffectFade, Autoplay, Navigation, Pagination],
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      centeredSlides: true,
      renderFraction: function (currentClass, totalClass) {
        return (
          '<span class="' +
          currentClass +
          '"></span>' +
          " <span class='pagi-br'> " + paginationConjunction + " </span> " +
          '<span class="' +
          totalClass +
          '"></span>'
        );
      }
    },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1,
    spaceBetween: 30,
  });
  swiper.slideToLoop(activeIndex);
};

export default modalSwiper;
